import { TaskSubTicketStatus } from 'dy-frontend-http-repository/lib/modules/TaskSubTicket/resources/TaskSubTicketResource';

// Exactly four phase statuses exist; all 12 transitions are permitted and none of them happen
// automatically, so this map is the single source of the labels shown anywhere in the UI.
//
// Every colour here is deliberately distinct from every colour in `taskStateInformation`. A
// phase status and a parent Request state are different things on the same screen, and reusing
// a parent's colour would read as if the phase carried that state.
const taskSubTicketStatusInformation: {
    [status in TaskSubTicketStatus]: {
        title: string;
        color: string;
    };
} = {
    to_design: {
        title: 'To Design',
        color: '#8F7BB5',
    },
    in_progress: {
        title: 'In Progress',
        color: '#C87619',
    },
    in_revision: {
        title: 'In Revision',
        color: '#B8478E',
    },
    complete: {
        title: 'Complete',
        color: '#2A8C4A',
    },
};

export default taskSubTicketStatusInformation;
